import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { EntityLocationExistApi } from 'api';
import { entityLocationExistQuery } from 'containers/Branding/Farm/Setting/commons/query';

export const createEntityLocationExist = createAsyncThunk(
  'entityLocationExist/createEntityLocationExist',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await EntityLocationExistApi.create(body);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createMultiEntityLocationExist = createAsyncThunk(
  'entityLocationExist/createMultiEntityLocationExist',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await EntityLocationExistApi.createMulti(body);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findEntityLocationExist = createAsyncThunk(
  'entityLocationExist/findEntityLocationExist',
  async (option: any, { rejectWithValue }) => {
    try {
      const response = await EntityLocationExistApi.find(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const filterEntityLocationExist = createAsyncThunk(
  'entityLocationExist/filterEntityLocationExist',
  async (_, { rejectWithValue }) => {
    try {
      const response = await EntityLocationExistApi.filter();

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface Update {
  id: string;
  body: any;
}
export const updateEntityLocationExist = createAsyncThunk(
  'entityLocationExist/updateEntityLocationExist',
  async (params: Update, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await EntityLocationExistApi.update(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const removeMultiEntityLocationExist = createAsyncThunk(
  'entityLocationExist/removeMultiEntityLocationExist',
  async (ids: string[], { rejectWithValue }) => {
    try {
      const response = await EntityLocationExistApi.removeMulti(ids);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const removeAllEntityLocationExistByOwnerID = createAsyncThunk(
  'entityLocationExist/removeAllEntityLocationExistByOwnerID',
  async (_, { rejectWithValue }) => {
    try {
      const response = await EntityLocationExistApi.removeAllByOwnerID();

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface State {
  data: Array<any>;
  reloadFlag: boolean;
  query: any;
}

const initialState: State = {
  data: [],
  reloadFlag: false,
  query: entityLocationExistQuery,
};

const entityLocationExistSlice = createSlice({
  name: 'entityLocationExist',
  initialState,
  reducers: {
    reloadEntityEntityLocationExist(state) {
      state.reloadFlag = !state.reloadFlag;
    },
  },
  extraReducers: builder => {
    builder.addCase(findEntityLocationExist.fulfilled, (state, action) => {
      const { data } = action.payload;
      state.data = data;
    });
    builder.addCase(filterEntityLocationExist.fulfilled, (state, action) => {
      const { data } = action.payload;
      state.data = data;
    });
    builder.addCase(
      createMultiEntityLocationExist.fulfilled,
      (state, action) => {
        state.data = state.data.concat(action.payload);
      }
    );
    builder.addCase(
      removeMultiEntityLocationExist.fulfilled,
      (state, action) => {
        const { data } = action.payload;
        const removedIds: string[] = data.map(item => item.id);
        state.data = state.data.filter(item => !removedIds.includes(item.id));
      }
    );
    builder.addCase(
      removeAllEntityLocationExistByOwnerID.fulfilled,
      (state, action) => {
        state.data = [];
      }
    );
  },
});

const { actions, reducer: entityEntityLocationExistReducer } =
  entityLocationExistSlice;

export const { reloadEntityEntityLocationExist } = actions;

export default entityEntityLocationExistReducer;
